// extracted by mini-css-extract-plugin
module.exports = {"video":"HeroVideo_video__3ZnQg","desktop":"HeroVideo_desktop__8XsqB","mobile":"HeroVideo_mobile___y5Db"};